const PersonalInformation = () => import('@/pages/personal/PersonalInformation.vue');
const SearchInformation = () => import('@/pages/personal/SearchInformation.vue');
const SearchPersonalDetail = () => import('@/pages/personal/SearchPersonalDetail.vue');
const RightPanel = () => import('c/common/right-panel.vue');
const excelPrint = () => import('@/pages/personal/excelPrint.vue');
export default [// 个人中心
	{
		path: '/PersonalInformation',
		name: 'PersonalInformation',
		component: PersonalInformation,
	},
	// 搜索出来的人员信息页面
	{
		path: '/SearchInformation',
		name: 'SearchInformation',
		component: SearchInformation,
		children: [
			{
				path: '/SearchRightPanel',
				name: 'SearchRightPanel',
				// meta: { parent: '/SearchInformation' },
				component: RightPanel,
				children: [
					{ // 搜索右滑详情页面
						path: '/SearchPersonalDetail/:id',
						name: 'SearchPersonalDetail',
						// meta: { parent: '/SearchInformation' },
						component: SearchPersonalDetail,
					},
				],
			},
		],
	},
	{
		path: '/excelPrint',
		name: 'excelPrint',
		component: excelPrint,
	},
];
